import React from "react";

const SupportInfo = ({ faqInfo }) => {
  return (
    <div className="faq-info-container">
    <label className="faq-question">{faqInfo?.question}</label>
    <div
      dangerouslySetInnerHTML={{ __html: faqInfo?.answer }}
      className="faq-answer"
    ></div>
  </div>
  );
};

export default SupportInfo;